import { useAppSelector } from "app/hooks";
import { useEffect } from "react";
import { parseUrlParams } from "shared/helpers/urlHelpers";

type UseInitialPoi = (krpanoFeaturesReady: boolean) => void;

/**
 * # Open an initial POI
 *
 * Format: `initialpoi=<poi_name>` (e.g. `initialpoi=poi%20name`, "%20" = " ")
 * Required: `poi_name`
 *
 * @related `usePoiRead`
 *
 * @param krpanoFeaturesReady see `AppInner`
 */
export const useInitialPoi: UseInitialPoi = (krpanoFeaturesReady) => {
  const initialPoi = parseUrlParams<string | null>("initialpoi", null);
  const initialPoiNumber = useAppSelector(
    (state) =>
      state.panorama.currentFieldDetails?.scoutPoints.find(
        (poi) => poi.name === initialPoi
      )?.poi_Number
  );

  // NOTE: That we want `initialPoi` in deps array
  // REASON: This means that the effect will only run once
  // We _don't_ want `initialPoiNumber`, since that will change whenever
  // `scoutPoints` changes (which would also be whenever the field changes)
  useEffect(() => {
    if (krpanoFeaturesReady && initialPoiNumber) {
      window.krpano.call(`Load_POI(null, ${initialPoiNumber});`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [krpanoFeaturesReady, initialPoi]);
};
